import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import {
  StyledH3,
  StyledSubtitle,
} from '../TextPageLandlord/TextPageLandlord.styles';

const LaMiglioreAssicurazione = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        La migliore garanzia sugli affitti
      </StyledH3>
      <StyledSubtitle tag="strong">
        Su che cosa si basa Protezione Zappyrent?
      </StyledSubtitle>
      <TextBody>
        Grazie alla selezione preventiva degli inquilini, Zappyrent mette a
        disposizione di ogni proprietario una dettagliata scheda del potenziale
        conduttore, contenente tutte le informazioni necessarie.
      </TextBody>
      <TextBody>
        Oltre al profilo individuale, viene analizzata la stabilità economica
        personale <strong>del potenziale inquilino</strong> o di coloro che ne
        sono i garanti (ad esempio, nel caso di studenti universitari oppure di
        lavoratori fuori sede).
      </TextBody>
      <TextBody>
        Inoltre, qualora il canone non fosse pagato il proprietario è
        ulteriormente tutelato poiché l’importo dovuto viene comunque{' '}
        <strong>versato da Zappyrent,</strong> che si occupa anche di un
        eventuale sfratto.
      </TextBody>
      <StyledSubtitle tag="strong">
        Zappyrent gestisce la procedura di sfratto
      </StyledSubtitle>
      <TextBody>
        <strong>
          Zappyrent valuta i potenziali conduttori con un punteggio da 0 a 100
          corrispondente alla loro affidabilità.
        </strong>{' '}
        Grazie a un algoritmo intelligente in grado di analizzare migliaia di
        informazioni in tempo reale, questa piattaforma riesce a limitare al
        massimo gli imprevisti derivanti da problematiche economiche.
      </TextBody>
      <TextBody>
        In caso si verificassero comunque problemi,{' '}
        <strong>Zappyrent offre gratuitamente un’assistenza legale</strong> per
        affrontare iter burocratici al riguardo e gestisce in prima persona le
        procedure per <strong>l’esecuzione di uno sfratto</strong>.
      </TextBody>
    </>
  );
};

export default LaMiglioreAssicurazione;
